import api from '../api';
import { PerformanceDay, PerformanceFilter, PerformanceReport } from '../../models/delivery-performance';

export function validatePerformanceFilter(filter: PerformanceFilter): string | undefined {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(filter.fromDate) || !/^\d{4}-\d{2}-\d{2}$/.test(filter.toDate)) return 'Choose both dates.';
  const days = (Date.parse(filter.toDate) - Date.parse(filter.fromDate)) / 86400000;
  if (!Number.isFinite(days) || days < 0 || days > 92) return 'Choose a period of up to 93 days, with To date on or after From date.';
  if (filter.executiveIds.length > 6 || filter.executiveIds.some(id => !Number.isSafeInteger(id) || id <= 0)) return 'Select up to six executives, or clear the selection for all.';
}
const root = 'api/DeliveryWork';
async function safely<T>(read: () => Promise<{ data: T }>): Promise<T> {
  try { return (await read()).data; }
  catch { throw new Error('Unable to load delivery performance. Check your report access and connection, then retry with a shorter period if needed.'); }
}
export function readPerformance(filter: PerformanceFilter, signal?: AbortSignal) {
  const error = validatePerformanceFilter(filter);
  if (error) return Promise.reject(new Error(error));
  const params = new URLSearchParams({ fromDate: filter.fromDate, toDate: filter.toDate });
  filter.executiveIds.forEach(id => params.append('executiveIds', String(id)));
  return safely<PerformanceReport>(() => api.get(`${root}/performance`, { params, signal }));
}
export function readPerformanceDay(executiveId: number, date: string, signal?: AbortSignal) {
  return safely<PerformanceDay>(() => api.get(`${root}/performance-day`, { params: { executiveId, date }, signal }));
}
export function readPerformanceExecutives() {
  return safely<{ id: number; name: string; phone: string }[]>(() => api.get(`${root}/performance-executives`));
}
